import { CSSProperties } from 'react';

interface ImagePuzzleProps {
  pieceOrder: number[];
  puzzleSize: number;
  imageSrc: string;
  strokeColor?: string;
}

export const ImagePuzzle: React.FC<ImagePuzzleProps> = ({
  pieceOrder,
  puzzleSize,
  imageSrc,
  strokeColor = '#cccccc',
}) => {
  let numRows = Math.sqrt(puzzleSize);
  let numCols = Math.sqrt(puzzleSize);

  if (puzzleSize === 6) {
    numRows = 2;
    numCols = 3;
  }

  const getPieceStyle = (pieceIndex: number): CSSProperties => {
    const originalRow = Math.floor(pieceIndex / numCols);
    const originalCol = pieceIndex % numCols;

    return {
      width: '100%',
      height: '100%',
      backgroundImage: `url(${imageSrc})`,
      backgroundSize: `${numCols * 100}% ${numRows * 100}%`,
      backgroundPosition: `${(originalCol / (numCols - 1)) * 100}% ${
        (originalRow / (numRows - 1)) * 100
      }%`,
      backgroundRepeat: 'no-repeat',
      boxSizing: 'border-box',
      border: `1px solid ${strokeColor}`,
    };
  };

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${numCols}, 1fr)`,
        gridTemplateRows: `repeat(${numRows}, 1fr)`,
        width: '100%',
        aspectRatio: '1',
      }}
    >
      {pieceOrder.map((pieceIndex, i) => (
        <div
          key={i}
          style={{ position: 'relative', width: '100%', height: '100%' }}
        >
          <div style={getPieceStyle(pieceIndex)} />
        </div>
      ))}
    </div>
  );
};
